import { viewPageSchema } from '@salescore/agent-contract'
import { Array } from 'effect'

// 会話の対象の view（#10076 の X-1）の決め方。新しいチャットの最初の指示を送るときに開いていた view を、そのチャットの対象にし、
// 以後の指示でも毎回送る。表示する view を変えても対象は変えない。
// runtime は前のターンの対象を引き継がず、会話を作り直すときは新しいターンの側から 30,000 字までしか入れないので、
// 最初の指示にだけ送ると、長いチャットで対象が抜ける（doc/impl/agent/ADR.md の ADR-500）。
// 覚えるのはこのタブの中だけで、履歴から開き直したチャットには対象がない

// 今開いている view。type は SALESCORE の view の種別（ViewConfigTypeEnum）のまま受ける
export interface OpenView {
  id: string
  type: string
}

// 対象にできる view の種別。BE は viewPageSchema の type にない種別（MCP のツールで読めないフォーム）を VIEW_NOT_SUPPORTED で断るので、同じ一覧を使う
const TARGET_VIEW_TYPES: readonly string[] = viewPageSchema.shape.type.options

/**
 * 指示を送るときに、そのチャットの会話の対象にする view の id を返す。決めるのは新しいチャットの最初の指示だけで、
 * 始めたチャットでは、開いている view があっても null を返す。view を開いていないか、対象にできない種別でも null。
 */
export const chooseTargetViewId = (isNewChat: boolean, openView: OpenView | null): string | null =>
  isNewChat && openView !== null && Array.contains(TARGET_VIEW_TYPES, openView.type) ? openView.id : null
